import I18nUpdater from '../sharedComponents/I18nUpdater.vue'
import { mapState } from 'vuex'
export default {
  components: {
    I18nUpdater
  },
  data () {
    return {
      i18nready: false
    }
  },
  computed: {
    ...mapState('i18n', {
      'i18n': state => state.i18n
    })
  },
  methods: {
    onI18nChangeState (value) {
      this.i18nready = value
    },
    enter () {
    },
    leave () {
    }
  }
}
